<template>
  <div class="home">
    <RexModalV3
      :show="getShowAddConfigureAlert"
      :title="$t('addAlert')"
      :enableFooter="true"
      @onClose="handleClose"
      width="80.625rem"
      :submitBtnProps="submitButtonDisable ? { disabled: true } : {}"
    >
      <template #body>
        <div class="m-body modal-body-top">
          <div class="d-flex justify-content-between mb-2 flex-wrap">
            <div class="d-flex flex-column">
              <div class="alert-form-subtext">
                <DisplayMessage :showMessage="showAIEnableMessage" />
                <i18n-t :keypath="getAlertFormLabel">
                  <span
                    v-for="(label, i) in channelNameToBeDeleted"
                    :key="`${label}-${i}`"
                    class="alert-form-subtext-highlight"
                  >
                    {{ label }}
                  </span>
                </i18n-t>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mb-4 flex-wrap">
            <div class="d-flex flex-column mt-4 max-width">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('alertName') + $t('asterisk')"
                />
              </div>
              <div>
                <RexModalInput
                  type="text"
                  placeholder
                  style="height: 2.5em; width: 20.75em"
                  v-model="alertName"
                  :value="alertName"
                  id="input-alert-name"
                  @onFocusout="(item) => checkforExistingAlert(item)"
                />
              </div>
              <RexInfoLabel
                :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
                :isError="true"
                :info="alertNameErrorInfo"
                v-if="alertNameErrorInfoEnable"
              />
            </div>
            <div class="d-flex flex-column mt-4 max-width" v-if="isCloud">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel :primaryLabel="$t('Cloud') + $t('asterisk')" />
              </div>
              <div>
                <RexSearchSelect
                  :data="getAWSAlertCapabilitiesList"
                  :current="currentCloud"
                  @onChoose="(newValue) => (currentCloud = newValue)"
                  :objectValueIndex="1"
                  :boldActive="true"
                  id="alert-form-field-k8-instance-type"
                  disabled
                />
              </div>
            </div>
            <div class="d-flex flex-column mt-4 max-width select-field">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="getPrimaryLabelForServiceHeader"
                />
              </div>
              <RexSearchSelect
                style="height: 2.5em; width: 20.75em"
                :current="currentApplication"
                :data="alertApplicationsWithWritePermission"
                @onChoose="(item) => selectApplicationOption(item)"
                :isSearch="true"
                :searchPlaceholder="$t(getSearchServicePlaceholder)"
                :objectValueIndex="1"
                id="search-select-service-name"
                :enableSearchBtn="true"
                :total="alertApplicationsWithWritePermissionCount"
                :isNextPageLoading="serviceLoading"
                :isSearchLoading="searchSeviceLoading"
                :disabled="!isAlertPage"
                @fetchMore="scrollAlertServices"
                @onSearch="onSearchAlertService"
              />
            </div>
            <div class="d-flex flex-column mt-4 max-width" v-if="isCloud">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t(getServiceHeader) + $t('asterisk')"
                />
              </div>
              <div>
                <RexSearchSelect
                  style="height: 2.5em; width: 20.75em"
                  :current="getCurrentCloudService"
                  @onChoose="(newValue) => (currentCloudService = newValue)"
                  :data="getRDSAlertCapabilitiesList"
                  :isSearch="true"
                  :searchPlaceholder="$t(getSearchServicePlaceholder)"
                  :objectValueIndex="1"
                  id="search-select-service-name-aws"
                  disabled
                />
              </div>
            </div>
            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="showDatabaseTypeDropDown"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('aws.databaseType') + $t('asterisk')"
                />
              </div>
              <div>
                <RexSearchSelect
                  :data="getDatabaseType"
                  :current="getCurrentCloudInstanceType"
                  @onChoose="(newValue) => (currentCloudDatabase = newValue)"
                  :objectValueIndex="1"
                  :boldActive="true"
                  id="alert-form-field-aws-instance-type"
                  disabled
                />
              </div>
            </div>
            <div class="d-flex flex-column mt-4 max-width" v-if="isK8Type">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('alert.instanceType') + $t('asterisk')"
                />
              </div>
              <div>
                <RexSearchSelect
                  :data="Alertk8Instances"
                  :current="currentK8Instance"
                  @onChoose="(item) => selectK8InstanceTypeOption(item)"
                  :objectValueIndex="1"
                  :boldActive="true"
                  id="alert-form-field-k8-instance-type"
                />
              </div>
            </div>
            <div class="d-flex flex-column mt-4 max-width">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel :primaryLabel="$t('metric') + $t('asterisk')" />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('metricEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexSearchSelect
                  :data="metrics"
                  :current="currentMetric"
                  :objectValueIndex="1"
                  width="20.75em"
                  @onChoose="(option) => onMetricChange(option, true)"
                  :searchPlaceholder="searchMetric"
                  id="search-select-metric-type"
                />
              </div>
            </div>
            <AlertK8sV2Field
              v-if="isK8Instance"
              :category="currentK8Instance"
              @onMultiSelect="onK8Change"
            />
            <AlertCustomDBField
              v-if="showCustomDbField"
              :serviceIdObj="getCurrentAlertApplication"
              :currentMetricObj="currentMetric"
              @onMultiSelect="onCustomDBChange"
            />
            <AlertCouchbaseField
              v-if="showCouchbaseField"
              :serviceIdObj="getCurrentAlertApplication"
              :currentMetricObj="currentMetric"
              @onMultiSelect="onCouchbaseChange"
            />
            <AlertMQField
              v-if="showMqInstances"
              :currentMetricObj="currentMetric"
              @onMultiSelect="onMQChange"
            />
            <div class="d-flex flex-column mt-4 max-width" v-if="showEndpoints">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('endpoint') + $t('asterisk')"
                />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('endpointEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexSearchSelect
                  :isEdit="true"
                  :key="instanceKey"
                  :data="endpoints"
                  :objectValueIndex="1"
                  :boldActive="true"
                  :isSearch="true"
                  :searchPlaceholder="$t('searchEndpoint')"
                  :multiSelect="true"
                  @onMultiSelect="(item) => multiSelectEndpoints(item)"
                  :multiSelectTitle="formSelectedTitleTextEndpoints"
                  id="search-select-endpoints"
                  class="select-sources-field"
                  :useParentData="true"
                  :enableSearchBtn="true"
                  @onSearch="onEnpointSearch"
                  :isSearchLoading="isSearchEpLoading"
                  :enableSelectedList="true"
                  :selectedList="currentEndpointsSelected"
                  @onRemoveOption="removeSelectedEndpoint"
                  :isNextPageLoading="endpointLoading"
                  :total="endpointCount"
                  @fetchMore="scrollEndpoints"
                  style="height: 2.5em; width: 20.75em"
                />
              </div>
            </div>
            <div class="d-flex flex-column mt-4 max-width" v-if="showInstances">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel :primaryLabel="getInstancesDropDownHeader" />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('instanceEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexSearchSelect
                  :isEdit="true"
                  :key="instanceKey"
                  :data="instances"
                  :objectValueIndex="1"
                  :boldActive="true"
                  :isSearch="true"
                  :searchPlaceholder="$t('searchInstance')"
                  :multiSelect="true"
                  @onMultiSelect="(item) => multiSelectInstances(item)"
                  :multiSelectTitle="formSelectedTitleTextInstances"
                  id="search-select-instances"
                  class="select-sources-field"
                  :useParentData="true"
                  :enableSearchBtn="true"
                  @onSearch="onInstanceSearch"
                  :isSearchLoading="isSearchInstLoading"
                  :enableSelectedList="true"
                  :selectedList="currentInstancesSelected"
                  @onRemoveOption="removeSelectedInstance"
                  :isNextPageLoading="instLoading"
                  :total="instanceCount"
                  @fetchMore="scrollInstances"
                  style="height: 2.5em; width: 20.75em"
                />
              </div>
            </div>
            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="isStatusTypeEnabled && statusTypeArray?.length > 0"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('statusType') + $t('asterisk')"
                />
              </div>
              <div>
                <RexSearchSelect
                  :data="statusTypeArray"
                  :current="selectedStatusType"
                  :objectValueIndex="1"
                  width="20.75em"
                  @onChoose="onStatusTypeChange"
                  id="search-select-metric-type"
                />
              </div>
            </div>
            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="isErrorCodeEnabled"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('errorCode') + $t('asterisk')"
                />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('metricEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexSearchSelect
                  :data="errorsCodeArray.errorCodes"
                  :current="selectedErrorCode"
                  :objectValueIndex="1"
                  width="20.75em"
                  @onChoose="onErroCodeChange"
                  id="search-select-metric-type"
                />
              </div>
            </div>
            <div class="d-flex flex-column mt-4 max-width">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('aggregationType') + $t('asterisk')"
                />
              </div>
              <div>
                <RexSearchSelect
                  :data="getAggregationType"
                  :current="currentAggregation"
                  :objectValueIndex="1"
                  style="height: 2.5em; width: 20.75em"
                  @onChoose="onAggregationChange"
                  :isSearch="false"
                  id="search-select-metric-type"
                />
              </div>
            </div>

            <div class="d-flex flex-column mt-4 max-width" v-if="!showAIFields">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('operator') + $t('asterisk')"
                />
              </div>
              <div>
                <RexSearchSelect
                  style="height: 2.5em; width: 20.75em"
                  :data="operators"
                  :current="currentOp"
                  :objectValueIndex="1"
                  :isSearch="false"
                  @onChoose="onOpChange"
                  id="search-select-operator"
                />
              </div>
            </div>

            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="showThreshold && !showAIFields"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('thresholdValue') + $t('asterisk')"
                />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('thresholdEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexFormInputDropdown
                  type="number"
                  placeholder
                  :options="threashHoldTimeUnits"
                  style="width: 20.75em; height: 2.5em"
                  :value="thresholdVal"
                  :unitRequired="threashHoldUnitRequired"
                  :isDropdown="isThreshHoldUnitRequired"
                  :boldActive="true"
                  id="input-thresholdVal"
                  :defualtOptions="selectedthresholdUnit"
                  @update="handleThresholdUnitChange"
                  :maxLength="thresholdMax"
                  @keydown="(event) => handleEvent(event, 'threshold')"
                />
              </div>
              <RexInfoLabel
                :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
                :isError="true"
                v-if="invalid.threshold"
                :info="getThresholdInfo"
              />
            </div>
            <AlertAIFields
              v-if="showAIFields"
              @keydownEventForAnomalyCount="handleEvent"
              @updateAnomalyCountVal="updateAnomalyCountVal"
              @updateSeverity="updateSeverity"
              :anomalyCountVal="anomalyCountVal"
              :currentSeverity="currentSeverity"
            />
            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="showNoOfBreaches"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('noOfBreaches') + $t('asterisk')"
                />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('noOfBreachesEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexFormInputDropdown
                  type="number"
                  placeholder
                  style="width: 20.75em; height: 2.5em"
                  :value="noOfBreachesVal"
                  :unitRequired="false"
                  :isDropdown="false"
                  :boldActive="true"
                  id="input-noOfBreaches"
                  @update="handlenoOfBreachesValChange"
                  @keydown="(event) => handleEvent(event, 'breaches')"
                  :maxLength="2"
                />
              </div>
              <RexInfoLabel
                :isError="true"
                v-if="noOfBreachesInfoEnable"
                :info="noOfBreachesInfo"
              />
            </div>
            <div class="d-flex flex-column mt-4 max-width">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('timePeriod') + $t('asterisk')"
                />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('timePeriodEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div :class="isPeriodReadOnly">
                <RexFormInputDropdown
                  type="number"
                  placeholder
                  :options="[selectedTimePeriodUnit]"
                  style="width: 20.75em; height: 2.5em"
                  :defualtOptions="selectedTimePeriodUnit"
                  :unitRequired="true"
                  :isDropdown="true"
                  :value="timePeriodVal"
                  @update="handleTimePeriodUnitChange"
                  id="input-timePeriod"
                  @keydown="(event) => handleEvent(event, 'period')"
                />
              </div>
              <RexInfoLabel
                :isError="true"
                v-if="timePeriodInfoEnable"
                :info="timePeriodInfo"
              />
            </div>
            <div class="d-flex flex-column mt-4 max-width">
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel :primaryLabel="$t('recoveryPeriod')" />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('recoveryPeriodEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexFormInputDropdown
                  type="number"
                  placeholder
                  style="width: 20.75em; height: 2.5em"
                  :defualtOptions="selectedRecoveryPeriodUnit"
                  :options="[selectedRecoveryPeriodUnit]"
                  :unitRequired="true"
                  :isDropdown="true"
                  :value="recoveryPeriodVal"
                  @update="handleRecoveryPeriodUnitChange"
                  id="input-recoveryPeriod"
                  @keydown="(event) => handleEvent(event, 'recovery')"
                />
              </div>
              <RexInfoLabel
                :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
                :isError="true"
                :info="recoveryPeriodErrorInfo"
                v-if="recoveryPeriodErrorEnable"
              />
            </div>
            <div
              v-if="showSdMultiplier"
              class="d-flex flex-column mt-4 max-width"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel :primaryLabel="$t('sdMultiplier')" />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('sdMultiplierEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexFormInputDropdown
                  type="number"
                  placeholder
                  style="width: 20.75em; height: 2.5em"
                  :unitRequired="false"
                  :value="sdMultiplierVal"
                  @update="handleSdMultiplierUnitChange"
                  id="input-sdMultiplier"
                  @keydown="(event) => handleEvent(event, 'sdMultiplier')"
                />
              </div>
              <RexInfoLabel
                :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
                :isError="true"
                :info="sdMultiplierErrorInfo"
                v-if="sdMultiplierErrorEnable"
              />
            </div>
            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="!showNoOfBreaches"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('silencePeriod') + $t('asterisk')"
                />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('silencePeriodEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexFormInputDropdown
                  type="number"
                  placeholder
                  style="height: 2.5em; width: 20.75em"
                  :defualtOptions="selectedSilencePeriodUnit"
                  :options="[selectedSilencePeriodUnit]"
                  :unitRequired="true"
                  :isDropdown="true"
                  :value="silencePeriodVal"
                  @update="handleSilencePeriodUnitChange"
                  id="input-silencePeriod"
                  @keydown="(event) => handleEvent(event, 'silence')"
                />
              </div>
              <RexInfoLabel
                :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
                :isError="true"
                :info="silencePeriodErrorInfo"
                v-if="silencePeriodErrorEnable"
              />
            </div>
            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="showNoOfBreaches"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel
                  :primaryLabel="$t('silencePeriod') + $t('asterisk')"
                />
                <BaseIcon
                  name="infofilledv2sm"
                  v-tooltip:right="{
                    content: $t('silencePeriodEllipsisMessage'),
                    disabled: false,
                  }"
                />
              </div>
              <div>
                <RexFormInputDropdown
                  type="number"
                  placeholder
                  style="height: 2.5em; width: 20.75em"
                  :defualtOptions="selectedSilencePeriodUnit"
                  :options="[selectedSilencePeriodUnit]"
                  :unitRequired="true"
                  :isDropdown="true"
                  :value="silencePeriodVal"
                  @update="handleSilencePeriodUnitChange"
                  id="input-silencePeriod"
                  @keydown="(event) => handleEvent(event, 'silence')"
                />
              </div>
              <RexInfoLabel
                :customStyle="'max-width:fit-content !important;word-wrap:break-word;'"
                :isError="true"
                :info="silencePeriodErrorInfo"
                v-if="silencePeriodErrorEnable"
              />
            </div>
            <div
              class="d-flex flex-column mt-4 max-width"
              v-if="hasNotificationAccess"
            >
              <div class="mb-lg-1 mb-xl-1">
                <RexModalLabel :primaryLabel="$t('notificationChannels')" />
              </div>
              <span v-if="notificationChannel.length > 0">
                <RexSearchSelect
                  v-model="notificationChannel"
                  :data="notificationChannel"
                  :objectValueIndex="1"
                  :boldActive="true"
                  :isSearch="true"
                  :searchPlaceholder="$t('searchChannel')"
                  :multiSelect="true"
                  @onMultiSelect="(item) => multiSelect(item)"
                  :multiSelectTitle="formSelectedTitleText"
                  :isEdit="true"
                  id="search-select-notificationChannel"
                />
              </span>
              <div v-else>
                <RexInfoLabel :info="$t('emptyNotifications')" />
                <div style="padding-top: 01em; margin-left: 0.1em">
                  <RexButtonV3
                    variant="default"
                    @onClick="showAddChannelPopup"
                    id="btn-alert-modal-clr"
                  >
                    {{ $t('createNewChannel') }}
                  </RexButtonV3>
                </div>
                <AddChannelModal
                  v-if="getShowAddChannel"
                  @nccStatus="updateNCStatus"
                />
              </div>
            </div>
            <div
              class="d-flex flex-column mt-4 max-width"
              id="dummy"
              style="width: 20.8em"
            >
              <div class="mb-lg-1 mb-xl-1"></div>
            </div>
          </div>
          <div class="d-flex justify-content-between mb-2 flex-wrap">
            <AddAlertTags
              :disableTag="showAIFields"
              :rows="tagData"
              :hasError="hasError"
              :errorMessage="alertTagErrorMessage"
              @rows="
                (rows, action, currentRow) =>
                  handleRowsAction(rows, action, currentRow)
              "
              @validateTagKeyOnBlur="validateTagKeyOnBlur"
              @validateTagValueOnBlur="validateTagValueOnBlur"
            ></AddAlertTags>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="modal-btn">
          <RexButtonV3
            variant="default"
            @onClick="clear"
            id="btn-alert-modal-clr"
            class="mr-4"
          >
            {{ $t('clear') }}
          </RexButtonV3>

          <RexButtonV3
            :disabled="submitButtonDisable"
            @onClick="submitForm"
            id="btn-alert-modal-add"
          >
            {{ $t('add') }}
          </RexButtonV3>
        </div>
      </template>
    </RexModalV3>
  </div>
</template>

<script>
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import RexModal from '@/rex-components/rex-modal.vue';
import RexModalSelect from '@/rex-components/rex-modal-select.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexModalInput from '@/rex-components/rex-modal-input.vue';
import RexFormInputDropdown from '@/rex-components/rex-modal-input-dropdown.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import { notificationSucess, notificationError } from '@/utils/notification';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import AddChannelModal from '@/components/Notification/AddChannel.vue';
import RexGenericFilter from '@/rex-components/RexGenericFilter.vue';
import AlertCouchbaseField from '@/components/AlertsV2/alert-form-fields/AlertCouchbaseField.vue';
import AlertMQField from '@/components/AlertsV2/alert-form-fields/AlertMQField.vue';
import { validateText } from '@/utils/emailAndUrlValidator';
import {
  ALERT_CAPABILITY_TYPE,
  ALL_SELECTED_INSTANCES,
  AWS,
  AWS_ALERT_CAPABILITIES,
  CLOUD_SUB_TYPE_MAPPER,
  DATABASE_TYPE,
  RDS_ALERT_CAPABILITIES,
} from '@/components/AlertsV2/constants.js';
import AlertCustomDBField from '@/components/AlertsV2/alert-form-fields//AlertCustomDBField.vue';
import { Capability } from '@/utils/enums/metricType';
import {
  ErrorCodes,
  StatusType,
} from '@/store/modules/alertV2/configure/config-constant';
import AlertsV2Utils from './alertsV2Utils.js';
import Messages from './constants';
import AddAlertTags from './AddTags.vue';
import { ALL } from '@/components/Log/log.constants';
import _ from 'lodash';
import {
  MAX_ENDPOINT_SELECTED,
  COUCHBASE_SUB,
  COUCHBASE_CLUSTER,
  MYSQL_SUB,
  CASSANDRA_SUB,
  ORACLE_SUB,
  K8_SUB,
  K8_CLUSTER_INSTANCE,
  MQ,
  CLOUD,
  POSTGRES_SUB,
  MSSQL_SUB,
  ANOMALY_COUNT,
  SEVERITY_OPTIONS,
  CRITICAL_SEV,
  MONGO_SUB,
  MAX_INSTANCE_SELECTED,
} from '@/components/AlertsV2/constants';
import {
  parseServiceObjFromApplication,
  validateJson,
} from '@/utils/helper-function';
import {
  couchbaseMetricMapper,
  dbTypeMapper,
} from '@/components/AlertsV2/alertsV2Utils';
import AlertK8sV2Field from '@/components/AlertsV2/alert-form-fields/AlertK8sV2Field.vue';
import {
  customStylesForSelectField,
  getSeverityValueForLabel,
  transformAndSortMetrics,
} from '@/components/AlertsV2/alertsV2Utils';
import DisplayMessage from '@/components/AlertsV2/DisplayMessage';
import { AlertInstanceType, InstanceType } from '@/components/K8M/k8.types';
import { aws_kafka_type } from '@/components/MQ/mq.types.js';
import { DISABLED_JVM_METRICS_GRAPH_FOR_AWS } from '@/utils/templates/mqTemplate/mq.constants.js';
import AlertAIFields from '@/components/AlertsV2/alert-form-fields/AlertAIFields.vue';
import { PAGE_SIZE_SCROLL } from '@/utils/constants';
import { permissionTypes } from '@/router/constant';
import { usePermissions } from '@/hooks/usePermissions';
import { NOTIFICATION_RESOURCE_GROUP } from '@/router/constant';

export default {
  name: 'CreateAlert',
  components: {
    RexButtonV3,
    RexSelectV3,
    RexModalV3,
    RexModal,
    RexModalSelect,
    RexModalLabel,
    RexModalInput,
    RexFormInputDropdown,
    RexInfoLabel,
    RexSearchSelect,
    AddChannelModal,
    RexGenericFilter,
    AddAlertTags,
    AlertCouchbaseField,
    AlertK8sV2Field,
    AlertMQField,
    AlertCustomDBField,
    AlertAIFields,
    DisplayMessage,
  },
  props: {
    instancesProp: {
      type: Array,
      default: () => [],
    },
    metricNameProp: {
      type: String,
      default: '',
    },
    instancePropType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      errorCodeMetrics: [
        'Error code',
        'Instance error code',
        'Endpoint error code',
      ],
      statusTypeMetrics: [
        'k8s_namespace_v2_namespace_status',
        'k8s_node_v2_status',
        'k8s_deployment_v2_status',
        'k8s_pods_v2_status_ready',
        'k8s_pods_v2_status_scheduled',
        'k8s_pods_v2_status',
      ],
      currentCloud: AWS.AWS,
      currentCloudService: AWS.AWS_RDS,
      currentCloudDatabase: AWS.MYSQL,
      alertNameErrorInfo: '',
      alertNameErrorInfoEnable: false,
      recoveryPeriodErrorEnable: false,
      recoveryPeriodErrorInfo: '',
      sdMultiplierErrorEnable: false,
      sdMultiplierErrorInfo: '',
      silencePeriodErrorEnable: false,
      silencePeriodErrorInfo: '',
      getAggregationType: [],
      noOfBreachesInfo: '',
      noOfBreachesInfoEnable: false,
      timePeriodInfo: '',
      timePeriodInfoEnable: false,
      channelNameToBeDeleted: [],
      alertName: '',
      searchMetric: this.$t('searchMetric'),
      showModal: false,
      currentOp: {},
      currentAggregation: {},
      currentMetric: {},
      selectedErrorCode: ErrorCodes.errorCodes[0],
      statusTypeArray: [],
      selectedStatusType: {},
      thresholdVal: 0,
      noOfBreachesVal: 0,
      recoveryPeriodVal: 0,
      silencePeriodVal: 5,
      sdMultiplierVal: 2,
      notificationChannel: [],
      currentNotificationChannelsSelected: [],
      currentNotificationChannelsSelectedKeys: [],
      currentEndpointsSelected: [],
      currentEndpointSelectedKeys: [],
      currentInstancesSelected: [],
      currentInstancesSelectedKeys: [],
      formSelectedTitleText: this.$t('alert.select-channel'),
      formSelectedTitleTextEndpoints: this.$t('alert.selectFromAvailable'),
      formSelectedTitleTextInstances: this.$t('alert.selectFromAvailable'),
      timePeriodVal: 1,
      selectedthresholdUnit: { key: 'ms', label: 'ms' },
      selectedThresholdType: '',
      showNoOfBreaches: false,
      showThreshold: true,
      showSdMultiplier: false,
      showEndpoints: false,
      selectedSilencePeriodUnit: { key: 'min', label: 'min' },
      selectedRecoveryPeriodUnit: { key: 'min', label: 'min' },
      operators: [],
      threashHoldUnitRequired: true,
      isThreshHoldUnitRequired: true,
      threashHoldTimeUnits: [
        { key: 'ms', label: 'ms' },
        { key: 'sec', label: 'sec' },
        { key: 'min', label: 'min' },
        { key: 'hrs', label: 'hrs' },
      ],
      metrics: [],
      endpoints: [],
      instances: [],
      instanceKey: 0,
      errorsCodeArray: ErrorCodes,
      selectedTimePeriodUnit: { key: 'min', label: 'min' },
      invalid: {
        alertName: true,
        serviceName: false,
        currentMetric: true,
        aggregationType: false,
        operators: false,
        threshold: false,
        noOfBreaches: false,
        timePeriod: false,
        recoveryPeriod: false,
        silencePeriod: false,
        tagIds: false,
        sdMultiplier: false,
      },
      submitButtonDisable: true,
      isPeriodReadOnly: 'disabled',
      min: 0,
      max: 0,
      thresholdMax: 10,
      isEdit: false,
      thresholdDisplayValue: '',
      isValidThresholdRange: false,
      isSearchEpLoading: false,
      tagData: [],
      hasError: false,
      alertTagErrorMessage: '',
      isCouchbaseType: false,
      showCouchbaseField: false,
      couchbaseIntances: [],
      mqInstances: [],
      K8Instances: [],
      customStylesForSelect: customStylesForSelectField,
      DBTypes: [CASSANDRA_SUB, ORACLE_SUB, MONGO_SUB],
      Alertk8Instances: AlertInstanceType,
      currentK8Instance: AlertInstanceType[0],
      AWS,
      showCustomDbField: false,
      customDbInstances: [],
      isCustomDbType: false,
      customDBTypes: [MYSQL_SUB, POSTGRES_SUB, MSSQL_SUB],
      enabledAI: false,
      anomalyCountVal: 1,
      currentSeverity: SEVERITY_OPTIONS[0],
      showAIEnableMessage: false,
      serviceLoading: false,
      searchAlertService: '',
      searchSeviceLoading: false,
      endpointCurrentPage: 1,
      endpointLoading: false,
      isSearchInstLoading: false,
      instLoading: false,
      instCurrentPage: 1,
    };
  },
  computed: {
    ...mapState('alertV2State/configure', ['metricsMap', 'currentSubType']),
    ...mapGetters('globalState/user', ['getTeamId']),
    ...mapState('alertV2State/configure', ['metricsMap']),
    ...mapState('globalState/settings', ['timezone']),
    ...mapGetters('globalState/user', {
      userInfoGetter: 'getUserInfo',
    }),

    ...mapGetters('alertV2State/configure', [
      'getShowAddConfigureAlert',
      'getCurrentAlertCapability',
      'getMeasurementUnits',
      'getCurrentAlertApplication',
      'getCurrentSubType',
    ]),
    ...mapGetters('channelState/overview', ['getShowAddChannel']),
    ...mapState('alertV2State/configure', [
      'initOperationsOptions',
      'currentApplication',
      'currentAlertApplication',
      'measurementUnits',
      'currentCapability',
      'isErrorCodeEnabled',
      'isStatusTypeEnabled',
      'endpointCount',
      'instanceCount',
      'serviceCurrentPage',
      'alertApplicationsWithWritePermission',
      'alertApplicationsWithWritePermissionCount',
    ]),
    ...mapGetters('globalState/settings', ['getDurationTime']),

    getCurrentCloudService() {
      return CLOUD_SUB_TYPE_MAPPER[this.getCurrentSubType.split('_')[0]];
    },
    getCurrentCloudInstanceType() {
      return this.getCurrentSubType.split('_')[1];
    },

    showAIFields() {
      return this.currentAggregation?.key === ANOMALY_COUNT;
    },
    getAlertFormLabel() {
      return this.showAIFields
        ? 'createAlertFormedLabelWithAnomaly'
        : this.showNoOfBreaches
          ? 'creatAlertFormedLabel'
          : 'creatAlertFormedLabelWithOutBreaches';
    },
    getAWSAlertCapabilitiesList() {
      return AWS_ALERT_CAPABILITIES;
    },
    getDatabaseType() {
      return DATABASE_TYPE;
    },
    getRDSAlertCapabilitiesList() {
      return RDS_ALERT_CAPABILITIES;
    },
    getThresholdInfo() {
      if (!this.isValidThresholdRange) {
        return this.getWarnInfo(Messages.OTHERS_CONSTANT.THRESHOLD_VALID_LIMIT);
      }
      if (this.currentMetric.key === Messages.APDEX_CONSTANT.SERVICE_APDEX) {
        return this.getWarnInfo(Messages.APDEX_CONSTANT.SERVICE_APDEX);
      } else if (
        this.currentMetric.key === Messages.APDEX_CONSTANT.BROWSER_APP_APDEX
      ) {
        return this.getWarnInfo(Messages.APDEX_CONSTANT.BROWSER_APP_APDEX);
      } else return this.getWarnInfo(Messages.OTHERS_CONSTANT.THRESHOLD);
    },

    getServiceHeader() {
      if (
        this.currentCapability?.key === Capability.LOG ||
        this.currentCapability?.key === Capability.ANALYTICS
      ) {
        return 'alert.savedSearches';
      }
      return 'service';
    },
    getInstancesDropDownHeader() {
      return (
        (this.isCloud && this.isLambda
          ? this.$t('aws.functions')
          : this.$t('aws.instance')) + this.$t('asterisk')
      );
    },
    getInstanceNameForDropDownMessage() {
      if (this.isCloud && this.isLambda) {
        return 'function';
      } else {
        return 'instance';
      }
    },
    getSearchServicePlaceholder() {
      if (
        this.currentCapability?.key === Capability.LOG ||
        this.currentCapability?.key === Capability.ANALYTICS
      ) {
        return 'alert.searchSavedSearch';
      }
      return 'searchService';
    },
    showInstances() {
      return (
        this.currentMetric?.isInstanceType &&
        this.currentMetric?.instances?.includes('instance') &&
        !this.isCouchbaseType &&
        !this.isMQType &&
        !this.isK8Instance &&
        !this.isCustomDbType
      );
    },
    isMQType() {
      const serviceInfo = parseServiceObjFromApplication(
        this.getCurrentAlertApplication,
      );
      return serviceInfo?.type === MQ;
    },
    showMqInstances() {
      return this.isMQType && this.currentMetric?.isInstanceType;
    },
    isK8Type() {
      const serviceInfo = parseServiceObjFromApplication(
        this.getCurrentAlertApplication,
      );
      return serviceInfo?.type === K8_SUB;
    },
    isCloud() {
      const serviceInfo = parseServiceObjFromApplication(
        this.getCurrentAlertApplication,
      );
      return serviceInfo?.type === CLOUD;
    },
    isAlertPage() {
      return this.$route.fullPath.includes('alertsV2');
    },
    isLambda() {
      return this.currentSubType === AWS.LAMBDA;
    },
    showDatabaseTypeDropDown() {
      return (
        this.isCloud && this.currentSubType.includes(ALERT_CAPABILITY_TYPE.RDS)
      );
    },
    isK8Instance() {
      return (
        this.isK8Type && this.currentK8Instance?.label !== K8_CLUSTER_INSTANCE
      );
    },
    getPrimaryLabelForServiceHeader() {
      return this.isCloud
        ? this.$t('aws.connectionName') + this.$t('asterisk')
        : this.$t(this.getServiceHeader) + this.$t('asterisk');
    },
    getTypeForInstanceProp() {
      return this.instancePropType === 'function'
        ? 'aws.instancesSelected'
        : 'aws.functionsSelected';
    },
    hasNotificationAccess() {
      const { hasCapabilityPermission } = usePermissions();

      return hasCapabilityPermission(NOTIFICATION_RESOURCE_GROUP);
    },
  },
  async mounted() {
    this.checkAI();
    await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
    await this.loadAndRefresh();
    if (!this.isAlertPage) {
      this.instances = [...this.instancesProp];
      this.currentMetric = this.metricsMap.find(
        (metric) => metric.key === this.metricNameProp,
      );
      const selectedInstances = this.instancesProp?.map((instance) => ({
        key: instance.value,
        label: instance.value,
        selected: true,
      }));
      this.multiSelectInstances(selectedInstances);
    }
  },
  methods: {
    ...mapActions('alertV2State/configure', [
      'SAVE_ALERT_RULE',
      'reloadConfiguredAlerts',
      'SEARCH_EXISTING_ALERT_RULE_NAME',
      'GET_ALERT_APPLICATIONS',
    ]),
    ...mapMutations('alertV2State/configure', [
      'setShowAddConfigureAlert',
      'setCurrentAlertApplication',
      'setIsErrorCodeEnabled',
      'setIsStatusTypeEnabled',
      'setAlertApplication',
      'setServiceCurrentPage',
    ]),
    ...mapMutations('channelState/overview', [
      'setShowAddChannel',
      'setCurrentChannel',
      'setRefreshChannels',
    ]),
    ...mapGetters('alertV2State/configure', [
      'getNotificationChannels',
      'getMetricsMap',
      'getAggregationMap',
      'getEndpoints',
      'getInstances',
    ]),
    ...mapActions('alertV2State/configure', [
      'GET_NOTIFICATION_CHANNELS',
      'GET_METRICS_MAP',
      'GET_ENDPOINTS',
      'GET_INSTANCES_WITH_COUNT',
    ]),
    ...mapActions('apmState/apmCommonState', ['getServiceLanguage']),
    validateText,
    ...mapActions('globalState/settings', ['checkAIenable']),
    async checkAI() {
      try {
        const params = {
          request: {
            teamId: this.getTeamId,
          },
        };
        const res = await this.checkAIenable(params);
        this.enabledAI = res.enabledAI;
      } catch (error) {
        console.log('error:', error);
        this.enabledAI = false;
      }
    },
    validateFields() {
      const validEndpoint = this.showEndpoints
        ? this.currentEndpointSelectedKeys &&
          this.currentEndpointSelectedKeys.length > 0
        : true;
      const validInstance = this.showInstances
        ? this.currentInstancesSelectedKeys &&
          this.currentInstancesSelectedKeys.length > 0
        : true;
      const validMQInstance = this.showMqInstances
        ? this.mqInstances?.length > 0
        : true;
      const validCouchbaseInstance = this.showCouchbaseField
        ? this.couchbaseIntances?.length > 0
        : true;
      const validK8Instances = this.isK8Instance
        ? this.K8Instances?.length > 0
        : true;
      const validateCustomDbInstance = this.showCustomDbField
        ? this.customDbInstances?.length > 0
        : true;
      const isEnabledAI = this.showAIFields && !this.enabledAI;
      if (
        !this.invalid.alertName &&
        !this.invalid.serviceName &&
        !this.invalid.currentMetric &&
        !this.invalid.aggregationType &&
        !this.invalid.operators &&
        !this.invalid.threshold &&
        !this.invalid.noOfBreaches &&
        !this.invalid.timePeriod &&
        !this.invalid.recoveryPeriod &&
        !this.invalid.silencePeriod &&
        !this.invalid.tagIds &&
        !this.invalid.sdMultiplier &&
        validEndpoint &&
        validInstance &&
        validMQInstance &&
        validCouchbaseInstance &&
        validK8Instances &&
        validateCustomDbInstance &&
        !isEnabledAI
      )
        return true;
      else return false;
    },
    handleCouchBaseField() {
      const serviceInfo = parseServiceObjFromApplication(
        this.getCurrentAlertApplication,
      );
      this.isCouchbaseType = COUCHBASE_SUB === serviceInfo?.sub;
      this.showCouchbaseField =
        COUCHBASE_SUB === serviceInfo?.sub &&
        couchbaseMetricMapper[this.currentMetric?.key] !== COUCHBASE_CLUSTER;
    },
    handleCustomDbFeild() {
      const serviceInfo = parseServiceObjFromApplication(
        this.getCurrentAlertApplication,
      );
      this.isCustomDbType = this.customDBTypes.includes(serviceInfo?.sub);
      this.showCustomDbField = this.isCustomDbType;
    },
    async loadAndRefresh() {
      try {
        const currentDBType = parseServiceObjFromApplication(
          this.getCurrentAlertApplication,
        )?.sub;
        this.metrics = [];
        this.selectedErrorCode = ErrorCodes.errorCodes[0];
        this.currentK8Instance = AlertInstanceType[0];
        this.hasNotificationAccess && (await this.updateNCStatus());
        this.operators = this.initOperationsOptions;
        this.currentOp = this.initOperationsOptions[0];
        this.currentAggregation = this.getAggregationType[0];
        await this.getMetricsByCapability();
        this.metrics = transformAndSortMetrics(this.metrics);
        if (this.metrics.length > 0) {
          this.currentMetric = this.metrics[0];
          this.onMetricChange(this.currentMetric);
        }
        this.selectedStatusType = {};
        this.formTopLabelDescription();
        this.endpointCurrentPage = 1;
        await this.GET_ENDPOINTS(this.getEndpointsParams());
        this.currentEndpointsSelected = [];
        this.currentEndpointSelectedKeys = [];
        this.formSelectedTitleEndpoint();
        await this.getEndpointsByServiceId();
        let properties = [];
        if (this.DBTypes.includes(currentDBType)) {
          properties = [
            {
              key: 'instance_type',
              value: dbTypeMapper[currentDBType],
            },
          ];
        }
        await this.GET_INSTANCES_WITH_COUNT(
          this.getInstancesParams('', properties),
        );
        this.currentInstancesSelected = [];
        this.currentInstancesSelectedKeys = [];
        await this.getInstancesByServiceId();
        this.handleCouchBaseField();
        this.multiSelectInstances([]);
        this.multiSelectEndpoints([]);
        this.handleCustomDbFeild();
        this.alertName && this.checkforExistingAlert(this.alertName);
      } catch (error) {
        console.log('error', error);
      }
    },
    checkforExistingAlert(ruleName) {
      this.alertNameErrorInfoEnable = false;
      this.invalid.alertName = false;
      if (ruleName === '' || ruleName?.trim()?.length === 0) {
        this.invalid.alertName = true;
        this.alertNameErrorInfoEnable = true;
        this.alertNameErrorInfo = this.$t('alertNameCantBeEmpty');
        this.submitButtonDisable = !this.validateFields();
        return;
      }
      if (!/^( )?[a-zA-Z0-9]+( [a-zA-Z0-9]+)*( )?$/.test(ruleName)) {
        this.invalid.alertName = true;
        this.alertNameErrorInfoEnable = true;
        this.alertNameErrorInfo = this.$t('alertInvalidCharacters');
        this.submitButtonDisable = !this.validateFields();
        return;
      }
      if (ruleName.length > 200) {
        this.invalid.alertName = true;
        this.alertNameErrorInfoEnable = true;
        this.alertNameErrorInfo = this.$t('alertNameLength');
        this.submitButtonDisable = !this.validateFields();
        return;
      }

      this.alertNameErrorInfoEnable = false;
      this.alertNameErrorInfo = '';

      const params = {
        ruleName,
        serviceId: this.getCurrentAlertApplication?.key,
      };
      this.SEARCH_EXISTING_ALERT_RULE_NAME(params)
        .then((response) => {
          if (response && response.data && response.data.data) {
            if (response.data.data.total > 0) {
              this.alertNameErrorInfoEnable = true;
              this.alertNameErrorInfo = this.$t('duplicateAlertExistError');
              this.invalid.alertName = true;
              this.submitButtonDisable = !this.validateFields();
            }
          }
        })
        .catch((err) => {
          //
        });
    },

    multiSelect(input) {
      this.currentNotificationChannelsSelected = [];
      this.currentNotificationChannelsSelectedKeys = [];
      input.forEach((channel) => {
        this.currentNotificationChannelsSelected.push(channel);
        this.currentNotificationChannelsSelectedKeys.push(channel.key);
      });
      this.formSelectedTitle();
    },
    multiSelectEndpoints(item) {
      if (
        this.currentEndpointsSelected?.length >= MAX_ENDPOINT_SELECTED &&
        'selected' in item &&
        !item.selected
      ) {
        notificationError(this.$t('alert.maximum20EndpointsCanBeSelected'));
        return;
      }
      this.endpoints = this.endpoints.map((obj) => {
        if (obj.label === item.label) obj.selected = !obj.selected;

        if (
          obj.selected &&
          !this.currentEndpointSelectedKeys.includes(obj.label)
        ) {
          this.currentEndpointsSelected.push(obj);
          this.currentEndpointSelectedKeys.push(obj.label);
        }

        if (
          !obj.selected &&
          this.currentEndpointSelectedKeys.includes(obj.label)
        ) {
          this.currentEndpointsSelected = this.currentEndpointsSelected.filter(
            (ep) => ep.label !== obj.label,
          );
          this.currentEndpointSelectedKeys =
            this.currentEndpointSelectedKeys.filter((key) => key !== obj.label);
        }
        return obj;
      });
      this.formSelectedTitleEndpoint();
    },
    multiSelectInstances(item) {
      if (
        this.currentInstancesSelected?.length >= MAX_INSTANCE_SELECTED &&
        'selected' in item &&
        !item.selected
      ) {
        notificationError(this.$t('alert.maximum20InstancesCanBeSelected'));
        return;
      }
      this.instances = this.instances.map((obj) => {
        if (obj.label === item.label) obj.selected = !obj.selected;
        if (
          obj.selected &&
          !this.currentInstancesSelectedKeys.includes(obj.label)
        ) {
          this.currentInstancesSelected.push(obj);
          this.currentInstancesSelectedKeys.push(obj.label);
        }

        if (
          !obj.selected &&
          this.currentInstancesSelectedKeys.includes(obj.label)
        ) {
          this.currentInstancesSelected = this.currentInstancesSelected.filter(
            (inst) => inst.label !== obj.label,
          );
          this.currentInstancesSelectedKeys =
            this.currentInstancesSelectedKeys.filter(
              (key) => key !== obj.label,
            );
        }
        return obj;
      });
      this.formSelectedTitleInstance();
    },
    formSelectedTitle() {
      let msg = '';
      this.formSelectedTitleText = '';
      let selectedChannel = this.currentNotificationChannelsSelected;
      if (selectedChannel.length === 0) {
        this.formSelectedTitleText = this.$t('alert.select-channel');
        return;
      }
      msg =
        selectedChannel.length +
        ' channel' +
        (selectedChannel.length === 1 ? '' : 's') +
        ' selected';
      this.formSelectedTitleText = msg;
    },
    formSelectedTitleEndpoint() {
      let msg = '';
      this.formSelectedTitleTextEndpoints = '';
      let selectedEndpoint = this.currentEndpointsSelected;
      this.submitButtonDisable = !this.validateFields();
      if (selectedEndpoint === null || selectedEndpoint.length === 0) {
        this.formSelectedTitleTextEndpoints = this.$t(
          'alert.selectFromAvailable',
        );
        return;
      }
      msg =
        selectedEndpoint.length +
        ' endpoint' +
        (selectedEndpoint.length === 1 ? '' : 's') +
        ' selected';
      this.formSelectedTitleTextEndpoints = msg;
    },
    formSelectedTitleInstance() {
      let msg = '';
      this.formSelectedTitleTextInstances = '';
      let selectedInstance = this.currentInstancesSelected;
      this.submitButtonDisable = !this.validateFields();
      if (selectedInstance === null || selectedInstance.length === 0) {
        this.formSelectedTitleTextInstances = this.$t(
          'alert.selectFromAvailable',
        );
        return;
      }
      msg =
        selectedInstance.length +
        ' ' +
        this.getInstanceNameForDropDownMessage +
        (selectedInstance.length === 1 ? '' : 's') +
        ' selected';
      this.formSelectedTitleTextInstances = msg;
    },
    handlenoOfBreachesValChange(input) {
      this.invalid.noOfBreaches = false;
      if (this.showNoOfBreaches) {
        if (
          input <= 0 ||
          input === '' ||
          input === undefined ||
          input === null
        ) {
          this.noOfBreachesVal = input;
          this.invalid.noOfBreaches = true;
          this.noOfBreachesInfoEnable = true;
          this.noOfBreachesInfo = this.$t('noOfBreachesValidationMessage');
        } else {
          if (Number(input) < this.max) {
            this.invalid.noOfBreaches = false;
            this.noOfBreachesInfoEnable = false;
            this.noOfBreachesInfo = '';
            this.noOfBreachesVal = input;
          } else {
            this.noOfBreachesVal = input;
            this.noOfBreachesInfoEnable = true;
            this.noOfBreachesInfo = this.$t('enterValidNumberMessage');
            this.invalid.noOfBreaches = true;
          }
        }
      }
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    handleTimePeriodUnitChange(input) {
      this.timePeriodInfoEnable = false;
      this.invalid.timePeriod = false;
      if (isNaN(input)) {
        this.selectedTimePeriodUnit = input;
      } else {
        input = Number(input);
        if (input === 0) {
          this.invalid.timePeriod = true;
          this.timePeriodInfoEnable = true;
          this.timePeriodVal = 0;
          this.timePeriodInfo = this.$t('timePeriodValidationMessage');
        } else if (input > 1440) {
          this.timePeriodInfoEnable = true;
          this.timePeriodInfo = this.$t('timePeriodValidationMessage');
        } else {
          this.invalid.timePeriod = false;
          this.timePeriodVal = input;
        }
      }
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    handleSilencePeriodUnitChange(input) {
      this.silencePeriodErrorEnable = false;
      this.invalid.silencePeriod = false;
      this.silencePeriodErrorInfo = '';
      this.submitButtonDisable = false;
      if (isNaN(input)) {
        this.selectedSilencePeriodUnit = input;
      } else {
        input = Number(input);
        if (input === 0) {
          this.invalid.silencePeriod = true;
          this.silencePeriodVal = 0;
          this.silencePeriodErrorEnable = true;
          this.silencePeriodErrorInfo = this.$t(
            'silencePeriodValidationMessage',
          );
        } else if (input > 1440) {
          this.silencePeriodErrorEnable = true;
          this.silencePeriodErrorInfo = this.$t(
            'silencePeriodValidationMessage',
          );
        } else {
          this.invalid.silencePeriod = false;
          this.silencePeriodVal = input;
        }
      }
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    handleRecoveryPeriodUnitChange(input) {
      this.recoveryPeriodErrorEnable = false;
      this.recoveryPeriodErrorInfo = '';
      if (input <= 0 || input === '' || input === undefined || input === null) {
        this.recoveryPeriodVal = input;
      }
      if (isNaN(input)) {
        this.selectedRecoveryPeriodUnit = input;
      } else {
        input = Number(input);
        if (input > 1440) {
          this.recoveryPeriodErrorEnable = true;
          this.recoveryPeriodErrorInfo = this.$t(
            'recoveryPeriodValidationMessage',
          );
        } else {
          this.recoveryPeriodVal = input === '' ? 0 : input;
        }
      }
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    handleSdMultiplierUnitChange(input) {
      this.invalid.sdMultiplier = false;
      this.sdMultiplierErrorEnable = false;
      this.sdMultiplierErrorInfo = '';
      input = Number(input);
      if (input > 100 || input < 1) {
        this.sdMultiplierErrorEnable = true;
        this.invalid.sdMultiplier = true;
        this.sdMultiplierErrorInfo = this.$t('sdMultiplierValidationMessage');
      }
      this.sdMultiplierVal = input;
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    async calculateThresholdValue(value) {
      let allUnits = await this.getMeasurementUnits;
      let allUnitsByType = allUnits[this.selectedThresholdType];
      let unit = allUnitsByType?.filter(
        (el) => el.unit === this.selectedthresholdUnit.key,
      );
      let threshholdCalculatedVal = 0;
      if (unit && unit[0])
        threshholdCalculatedVal =
          (unit[0].multiplier ? unit[0].multiplier : 0) * Number(value);
      return threshholdCalculatedVal;
    },
    async handleThresholdUnitChange(input) {
      this.invalid.threshold = false;
      this.isValidThresholdRange = true;
      let validLimit = 18;
      let calTHValue;
      if (input <= 0 || input === '' || input === undefined || input === null) {
        this.thresholdVal = input;
      }
      if (isNaN(input)) {
        this.selectedthresholdUnit = input;
        calTHValue = await this.calculateThresholdValue(this.thresholdVal);
        if (String(calTHValue).length > validLimit) {
          this.invalid.threshold = true;
          this.isValidThresholdRange = false;
          this.submitButtonDisable = !this.validateFields();
          this.formTopLabelDescription();
          return;
        }
      } else {
        calTHValue = await this.calculateThresholdValue(input);
        if (String(calTHValue).length > validLimit) {
          this.invalid.threshold = true;
          this.isValidThresholdRange = false;
          this.submitButtonDisable = !this.validateFields();
          this.formTopLabelDescription();
          return;
        }
        input = Number(input);
        if (input === 0 && !this.isThreshHoldUnitRequired) {
          this.selectedthresholdUnit = { key: 'na', label: '' };
        }
        if (
          this.currentMetric.key === Messages.APDEX_CONSTANT.SERVICE_APDEX ||
          this.currentMetric.key === Messages.APDEX_CONSTANT.BROWSER_APP_APDEX
        ) {
          this.thresholdVal = input;
          if (input > 1) {
            this.invalid.threshold = true;
            this.submitButtonDisable = !this.validateFields();
            return;
          } else {
            let newTHV =
              input.toString().length > 4
                ? Number(input.toString().substring(0, 4))
                : input;
            if (this.thresholdVal === newTHV) {
              this.thresholdVal = newTHV + '';
            } else this.thresholdVal = newTHV;
          }
        } else {
          if (
            this.currentMetric.label ===
            Messages.OTHERS_CONSTANT.INSTANCE_AVAILABILITY
          ) {
            if (input >= 1001) {
              this.invalid.threshold = true;
              this.thresholdVal = input;
              this.submitButtonDisable = !this.validateFields();
              return;
            }
          }
          if (
            this.currentMetric.label ===
              Messages.OTHERS_CONSTANT.AVAILABILITY ||
            parseInt(this.max) === 100
          ) {
            if (input >= 101) {
              this.invalid.threshold = true;
              this.thresholdVal = input;
              this.submitButtonDisable = !this.validateFields();
              return;
            }
          }
          if (parseInt(this.max) === 100 && input > parseInt(this.max)) {
            this.invalid.threshold = true;
            this.thresholdVal = 100;
            this.submitButtonDisable = !this.validateFields();
            return;
          }
          this.thresholdVal = input;
          this.thresholdDisplayValue = input;
        }
      }
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    async updateNCStatus() {
      await this.GET_NOTIFICATION_CHANNELS();
      await this.getNotificationChannelsList();
    },
    async getMetricsByCapability() {
      let _payload = {
        capability: AlertsV2Utils.CurrentAlertCapabilityValue(
          this.getCurrentAlertCapability.key,
        ),
        serviceId: this.getCurrentAlertApplication.key,
      };
      await this.GET_METRICS_MAP(_payload);
      this.metrics = await this.getMetricsMap();
      if (this.isK8Type) {
        this.metrics = this.metrics.filter((metric) => {
          return metric?.category === InstanceType[this.currentK8Instance.key];
        });
      }
    },
    async getEndpointsByServiceId() {
      try {
        this.endpoints = [];
        const endpoints = await this.getEndpoints();
        if (Array.isArray(endpoints) && endpoints.length > 0) {
          this.endpoints = endpoints.map((endpoint) => ({
            key: endpoint.key,
            label: endpoint.label,
            selected:
              this.currentEndpointSelectedKeys?.includes(endpoint.label) ||
              false,
          }));
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    async onEnpointSearch(search) {
      try {
        this.isSearchEpLoading = true;
        this.endpointCurrentPage = 1;
        await this.GET_ENDPOINTS(this.getEndpointsParams(search));
        const endpoints = await this.getEndpoints();
        if (Array.isArray(endpoints)) {
          const updatedEndpoints = endpoints.map((e) => ({
            key: e.key,
            label: e.label,
            selected:
              this.currentEndpointSelectedKeys?.includes(e.label) || false,
          }));
          this.endpoints = updatedEndpoints;
        }
        this.isSearchEpLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isSearchEpLoading = false;
        this.endpoints = [];
      }
    },
    removeSelectedEndpoint(obj) {
      this.currentEndpointsSelected = this.currentEndpointsSelected.filter(
        (ep) => ep.label != obj.label,
      );
      this.currentEndpointSelectedKeys = this.currentEndpointsSelected.map(
        (obj) => obj.label,
      );

      this.endpoints = this.endpoints.map((ep) => {
        if (ep.label === obj.label) {
          ep.selected = false;
        }
        return ep;
      });

      this.formSelectedTitleEndpoint();
    },
    async getInstancesByServiceId() {
      this.instances = [];
      const instances = await this.getInstances();
      if (this.isMQType && this.hasAwsBroker(instances)) {
        this.metrics = this.metrics.filter(
          (metric) => !DISABLED_JVM_METRICS_GRAPH_FOR_AWS.includes(metric.key),
        );
      }
      if (Array.isArray(instances) && instances.length > 0) {
        this.instances = instances.map((instance) => ({
          key: instance.key,
          label: instance.label,
          selected:
            this.currentInstancesSelectedKeys?.includes(instance.label) ||
            false,
        }));
      }
    },
    hasAwsBroker(instanceId) {
      try {
        if (!Array.isArray(instanceId)) return false;
        for (let jsonObj of instanceId) {
          if (jsonObj?.metaProperty1) {
            if (
              validateJson(jsonObj.metaProperty1) &&
              JSON.parse(jsonObj.metaProperty1)?.type === aws_kafka_type
            )
              return true;
          }
        }
      } catch (e) {
        console.error('Error while parsing metaproperty1', e);
        return false;
      }
      return false;
    },
    async onInstanceSearch(search) {
      try {
        this.isSearchInstLoading = true;
        this.instCurrentPage = 1;
        await this.GET_INSTANCES_WITH_COUNT(this.getInstancesParams(search));
        const instances = await this.getInstances();
        if (Array.isArray(instances)) {
          const updatedInstances = instances.map((inst) => ({
            key: inst.key,
            label: inst.label,
            selected:
              this.currentInstancesSelectedKeys?.includes(inst.label) || false,
          }));
          this.instances = updatedInstances;
        }
        this.isSearchInstLoading = false;
      } catch (error) {
        console.log('error', error);
        this.isSearchInstLoading = false;
        this.instances = [];
      }
    },
    removeSelectedInstance(obj) {
      this.currentInstancesSelected = this.currentInstancesSelected.filter(
        (inst) => inst.label != obj.label,
      );
      this.currentInstancesSelectedKeys = this.currentInstancesSelected.map(
        (obj) => obj.label,
      );

      this.instances = this.instances.map((instnace) => {
        if (instnace.label === obj.label) {
          instnace.selected = false;
        }
        return instnace;
      });

      this.formSelectedTitleInstance();
    },
    async getNotificationChannelsList() {
      this.notificationChannel = [];
      const channels = await this.getNotificationChannels();
      if (Array.isArray(channels) && channels.length > 0) {
        channels.forEach((channel) => {
          const ch = {
            key: channel.channelId,
            label: channel.channelName,
            selected: false,
          };
          this.notificationChannel.push(ch);
        });
      }
    },
    formTopLabelDescription() {
      if (this.getCurrentAlertApplication === undefined) {
        return;
      }
      this.channelNameToBeDeleted = [];
      if (this.currentAggregation?.key === ANOMALY_COUNT) {
        this.channelNameToBeDeleted.push(
          this.getCurrentAlertApplication.label,
          this.currentMetric?.label.toLowerCase(),
          getSeverityValueForLabel(this.currentSeverity),
          this.anomalyCountVal,
          this.timePeriodVal + ' ' + this.selectedTimePeriodUnit.label,
          this.recoveryPeriodVal + ' ' + this.selectedRecoveryPeriodUnit.label,
        );
      }
      this.channelNameToBeDeleted.push(this.getCurrentAlertApplication.label);
      if (this.errorCodeMetrics.includes(this.currentMetric.label)) {
        this.channelNameToBeDeleted.push(
          (this.currentMetric.label
            ? this.currentMetric.label.toLowerCase()
            : this.currentMetric.label) +
            ' ' +
            Object.keys(this.selectedErrorCode)[0],
        );
      } else if (this.statusTypeMetrics.includes(this.currentMetric.key)) {
        this.channelNameToBeDeleted.push(
          (this.currentMetric.label
            ? this.currentMetric.label.toLowerCase()
            : this.currentMetric.label) +
            ' status type ' +
            Object.values(this.selectedStatusType)[0],
        );
      } else
        this.channelNameToBeDeleted.push(
          this.currentMetric.label
            ? this.currentMetric.label.toLowerCase()
            : this.currentMetric.label,
        );
      this.channelNameToBeDeleted.push(
        this.currentOp.label
          ? this.currentOp.label.toLowerCase()
          : this.currentOp.label,
      );
      this.channelNameToBeDeleted.push(
        this.currentAggregation && this.currentAggregation.key === 'DYNAMIC'
          ? 'dynamic baseline threshold'
          : this.thresholdVal + ' ' + this.selectedthresholdUnit.label,
      );
      if (this.showNoOfBreaches)
        this.channelNameToBeDeleted.push(
          this.noOfBreachesVal == 1 || this.noOfBreachesVal == 0
            ? this.noOfBreachesVal + ' time'
            : this.noOfBreachesVal + ' times',
        );
      this.channelNameToBeDeleted.push(this.timePeriodVal);
      this.channelNameToBeDeleted.push(' ' + this.selectedTimePeriodUnit.label);
      this.channelNameToBeDeleted.push(this.recoveryPeriodVal);
      this.channelNameToBeDeleted.push(
        ' ' + this.selectedRecoveryPeriodUnit.label,
      );
    },
    showAddChannelPopup() {
      this.setCurrentChannel({});
      this.setShowAddChannel(true);
    },
    async selectApplicationOption(item) {
      this.setCurrentAlertApplication(item);
      if (this.getCurrentAlertCapability.key === Capability.APM) {
        await this.getServiceLanguage({
          serviceId: this.getCurrentAlertApplication?.key,
        });
      }
      await this.loadAndRefresh();
    },
    async selectK8InstanceTypeOption(item) {
      this.currentK8Instance = item;
    },
    clicked() {
      this.setShowAddConfigureAlert(false);
    },
    hide(evt) {
      if (evt.trigger === 'backdrop') {
        evt.preventDefault();
        this.showModal = false;
      }
    },
    clearValidations() {
      // Disable error messages
      this.alertNameErrorInfoEnable = false;

      this.invalid.alertName = false;
      this.invalid.serviceName = false;
      this.invalid.currentMetric = false;
      this.invalid.aggregationType = false;
      this.invalid.operators = false;
      this.invalid.threshold = false;
      this.invalid.noOfBreaches = false;
      this.invalid.timePeriod = false;
      this.invalid.recoveryPeriod = false;
      this.invalid.silencePeriod = false;
      this.invalid.sdMultiplier = false;
    },
    clear(isNormal) {
      this.timePeriodInfoEnable = false;
      this.silencePeriodErrorEnable = false;
      this.recoveryPeriodErrorEnable = false;
      this.sdMultiplierErrorEnable = false;
      this.alertName = '';
      if (isNormal) {
        this.setCurrentAlertApplication(
          this.alertApplicationsWithWritePermission[0],
        );
      }
      this.currentMetric = this.metrics[0];
      this.currentAggregation = this.getAggregationType[0];
      this.currentOp = this.initOperationsOptions[0];
      this.thresholdVal = 0;
      this.noOfBreachesVal = 1;
      this.timePeriodVal = 1;
      this.recoveryPeriodVal = 0;
      this.sdMulitplierVal = 2;
      this.silencePeriodVal = 5;
      this.anomalyCountVal = 1;
      this.currentSeverity = SEVERITY_OPTIONS[0];
      this.notificationChannel.forEach((channel) => {
        channel.selected = false;
      });
      this.endpoints.forEach((ep) => {
        ep.selected = false;
      });
      // this.threashHoldTimeUnits = []
      this.selectedErrorCode = ErrorCodes.errorCodes[0];
      this.selectedStatusType = {};
      this.setIsErrorCodeEnabled(false);
      this.setIsStatusTypeEnabled(false);
      this.handleThresholdUnitChange(this.threashHoldTimeUnits[0]);
      this.multiSelect([]);
      this.multiSelectEndpoints([]);
      this.multiSelectInstances([]);
      this.clearValidations();
      this.invalid.alertName = true;
      this.submitButtonDisable = true;
      this.tagData = [
        {
          key: '',
          value: '',
        },
      ];
      this.hasError = false;
      this.alertTagErrorMessage = '';
      this.instances.forEach((instance) => {
        instance.selected = false;
      });
    },
    handleClose() {
      this.setShowAddConfigureAlert(false);
      this.setRefreshChannels(false);
    },
    formValid() {
      this.alertNameErrorInfoEnable = false;
      this.timePeriodInfoEnable = false;
      this.noOfBreachesInfoEnable = false;
      this.recoveryPeriodErrorEnable = false;
      this.silencePeriodErrorEnable = false;
      this.invalid.alertName = false;
      this.invalid.serviceName = false;
      this.invalid.currentMetric = false;
      this.invalid.aggregationType = false;
      this.invalid.operators = false;
      this.invalid.threshold = false;
      this.invalid.noOfBreaches = false;
      this.invalid.timePeriod = false;
      this.invalid.recoveryPeriod = false;
      this.invalid.silencePeriod = false;
      this.invalid.sdMultiplier = false;
    },
    async submitForm() {
      this.threshold = this.currentMetric.transform
        ? this.currentMetric.transform(this.threshold)
        : this.threshold;
      this.formValid();
      if (
        !this.invalid.threshold &&
        !this.invalid.period &&
        !this.invalid.count &&
        !this.invalid.silencePeriod
      ) {
        this.submitButtonDisable = true;
        let user =
          this.userInfoGetter.firstName + ' ' + this.userInfoGetter.lastname;
        let allUnits = await this.getMeasurementUnits;
        let allUnitsByType = allUnits[this.selectedThresholdType];
        let unit = allUnitsByType?.filter(
          (el) => el.unit === this.selectedthresholdUnit?.key,
        );
        let threshholdCalculatedVal = 0;

        if (unit && unit[0]) {
          threshholdCalculatedVal =
            (unit[0].multiplier ? unit[0].multiplier : 0) *
            Number(this.thresholdVal);
        } else threshholdCalculatedVal = Number(this.thresholdVal);
        // TODO Need to Check for Hours Based Validation for long digits
        if (
          this.currentMetric?.key === Messages.APDEX_CONSTANT.SERVICE_APDEX ||
          this.currentMetric?.key === Messages.APDEX_CONSTANT.BROWSER_APP_APDEX
        ) {
          if (this.thresholdVal > 1 || this.thresholdVal <= 0) {
            this.invalid.threshold = true;
            return;
          }
        } else {
          if (
            this.currentMetric.label ===
            Messages.OTHERS_CONSTANT.INSTANCE_AVAILABILITY
          ) {
            if (this.thresholdVal >= 1001) {
              this.invalid.threshold = true;
              return;
            }
          }
          if (
            this.currentMetric.label ===
              Messages.OTHERS_CONSTANT.AVAILABILITY ||
            parseInt(this.max) === 100
          ) {
            if (this.thresholdVal >= 101) {
              this.invalid.threshold = true;
              return;
            }
          }
          if (
            parseInt(this.max) === 100 &&
            this.thresholdVal > parseInt(this.max)
          ) {
            this.invalid.threshold = true;
            this.thresholdVal = 100;
            this.submitButtonDisable = !this.validateFields();
            return;
          }
          // threshholdCalculatedVal = Number(this.thresholdVal);
        }
        let aggValue =
          this.currentAggregation?.key === ANOMALY_COUNT
            ? this.anomalyCountVal
            : this.showSdMultiplier
              ? parseInt(this.sdMultiplierVal)
              : parseInt(this.noOfBreachesVal);
        let form = {
          active: true,
          ruleName: this.alertName?.trim(),
          metricName: this.currentMetric?.key,
          metricDisplayName: this.currentMetric.label,
          aggregationType: this.currentAggregation?.key.toUpperCase(),
          aggregationValue: aggValue,
          period: parseInt(this.timePeriodVal),
          operation: this.currentOp.key,
          silencePeriod: parseInt(this.silencePeriodVal),
          recoveryPeriod: parseInt(this.recoveryPeriodVal),
          createdBy: user,
          modifiedBy: user,
          serviceId: this.currentApplication.key,
          channels: this.currentNotificationChannelsSelectedKeys,
          threshold: threshholdCalculatedVal,
          thresholdDisplayValue: this.thresholdVal,
          thresholdDisplayUnit: this.selectedthresholdUnit.key,
          timezone: this.timezone,
          isInstanceType: this.currentMetric.isInstanceType,
          ...(this.currentAggregation?.key === ANOMALY_COUNT && {
            severity: this.currentSeverity?.label,
          }),
        };
        if (this.isErrorCodeEnabled && this.currentMetric.filters !== null) {
          form['filters'] = [
            {
              key: this.currentMetric.filters[0].key,
              value: Object.keys(this.selectedErrorCode)[0],
            },
          ];
        }
        if (this.isStatusTypeEnabled && this.currentMetric.filters !== null) {
          form['filters'] = [
            {
              key: this.currentMetric.filters[0].key,
              value: Object.keys(this.selectedStatusType)[0],
            },
          ];
        }
        if (this.showEndpoints) {
          const instances = [];
          if (
            Array.isArray(this.currentEndpointsSelected) &&
            this.currentEndpointsSelected.length > 0
          ) {
            this.currentEndpointsSelected.forEach((endpoint) => {
              const ep = {
                key: 'endpoint',
                value: endpoint.label,
              };
              instances.push(ep);
            });
          }
          form['instances'] = instances;
        }
        if (this.showInstances) {
          const instances = [];
          if (
            Array.isArray(this.currentInstancesSelected) &&
            this.currentInstancesSelected.length > 0
          ) {
            this.currentInstancesSelected.forEach((instance) => {
              let instanceValue = instance.label;
              let instanceValues = instance.key.split('_');
              if (instanceValues && instanceValues.length > 1) {
                instanceValue = atob(instanceValues[1]);
              }
              const inst = {
                key: 'instance',
                value: instanceValue,
              };
              instances.push(inst);
            });
          }
          form['instances'] = instances;
        }
        let taggedData = this.tagData.filter((tag) => tag.key !== '');
        if (taggedData.length === 0) {
          taggedData = null;
        }
        form['alertTags'] = taggedData;
        if (this.showMqInstances) {
          let instances = this.mqInstances.map((value) => ({
            key: 'instance',
            value,
          }));
          form['instances'] = instances;
        }
        if (this.isK8Instance) {
          let instances = this.K8Instances.map((value) => ({
            key: 'instance',
            value,
          }));
          form['instances'] = instances;
        }
        if (this.showCouchbaseField) {
          let instances = this.couchbaseIntances.map((value) => ({
            key: 'instance',
            value,
          }));
          form['instances'] = instances;
        }
        if (this.showCustomDbField) {
          let instances = this.customDbInstances.map((value) => ({
            key: 'instance',
            value,
          }));
          form['instances'] = instances;
        }
        await this.SAVE_ALERT_RULE(form)
          .then(async (response) => {
            if (!response.data.success) {
              this.submitButtonDisable = false;
              notificationError(response.data.message);
            } else {
              this.submitButtonDisable = false;
              this.clear(false);
              this.setShowAddConfigureAlert(false);
              notificationSucess(response.data.message);
            }
          })
          .catch(async (err) => {
            if (err?.response?.status === 409) {
              notificationError(err.response?.data?.message);
            } else if (err?.response?.status === 400) {
              notificationError(err.response?.data?.errors?.[0]);
            } else if (err?.response?.data) {
              let errorData = err.response.data;
              this.handleExceptions(errorData);
            }
          });
        await this.reloadConfiguredAlerts(true);
      }
    },
    handleExceptions(errorData) {
      let status = errorData.status;
      if (status === Messages.OTHERS_CONSTANT.BAD_REQUEST) {
        this.submitButtonDisable = false;
        let errorArray = errorData.errors;
        errorArray.forEach((channel) => {
          const arry = channel.split(':');
          const field = arry[0];
          let msg = arry[1];
          switch (field) {
            case Messages.OTHERS_CONSTANT.RULE_NAME:
              this.alertNameErrorInfoEnable = true;
              this.alertNameErrorInfo =
                this.$t(Messages.OTHERS_CONSTANT.RULE_NAME) + ' ' + msg;
              break;
            case Messages.OTHERS_CONSTANT.PERIOD:
              this.timePeriodInfoEnable = true;
              this.timePeriodInfo =
                this.$t(Messages.OTHERS_CONSTANT.PERIOD) + ' ' + msg;
              break;
            case Messages.OTHERS_CONSTANT.NO_OF_BREACHES:
              this.noOfBreachesInfoEnable = true;
              this.noOfBreachesInfo =
                this.$t(Messages.OTHERS_CONSTANT.NO_OF_BREACHES) + ' ' + msg;
              break;
            case Messages.OTHERS_CONSTANT.RECOVERY_PERIOD:
              this.recoveryPeriodErrorEnable = true;
              this.recoveryPeriodErrorInfo =
                this.$t(Messages.OTHERS_CONSTANT.RECOVERY_PERIOD) + ' ' + msg;
              break;
            case Messages.OTHERS_CONSTANT.SILENCE_PERIOD:
              this.silencePeriodErrorEnable = true;
              this.silencePeriodErrorInfo =
                this.$t(Messages.OTHERS_CONSTANT.SILENCE_PERIOD) + ' ' + msg;
              break;
            case Messages.OTHERS_CONSTANT.SERVICE_ID:
              notificationError(this.$t('emptyServiceNameV2Message'));
              break;
          }
        });
      }
    },

    onOpChange(option) {
      this.currentOp = option;
    },
    onErroCodeChange(option) {
      this.selectedErrorCode = option;
    },
    onStatusTypeChange(option) {
      this.selectedStatusType = option;
    },
    async onMetricChange(option, isFromDRopdownSelected) {
      this.setIsErrorCodeEnabled(false);
      this.setIsStatusTypeEnabled(false);

      this.timePeriodVal = 1;
      this.isPeriodReadOnly = '';

      this.showEndpoints =
        this.currentMetric?.isInstanceType &&
        this.currentMetric?.instances?.includes('endpoint');
      this.showCouchbaseField =
        this.currentMetric?.isInstanceType &&
        this.currentMetric?.instances?.includes('instance') &&
        this.isCouchbaseType;
      this.showCustomDbField =
        this.currentMetric.isInstanceType &&
        this.currentMetric.instances.includes('instance') &&
        this.isCustomDbType;

      this.instanceKey++;

      if (option.label === Messages.OTHERS_CONSTANT.INSTANCE_AVAILABILITY) {
        this.timePeriodVal = 5;
        this.isPeriodReadOnly = 'disabled';
        this.maxLength = 3;
      }
      if (this.max === 100) {
        this.maxLength = 3;
      }
      if (this.errorCodeMetrics.includes(option.label)) {
        this.setIsErrorCodeEnabled(true);
      }
      if (this.isK8Type && this.statusTypeMetrics.includes(option.key)) {
        this.setIsStatusTypeEnabled(true);
      }
      this.threashHoldUnitRequired = true;
      this.isThreshHoldUnitRequired = true;
      this.thresholdVal = 0;
      if (!option) return;
      let _aggregation = await this.getAggregationMap().filter(function (el) {
        return el.metric === option.key && el.metricLabel === option.label;
      });
      this.min = _aggregation[0] ? _aggregation[0].min : 0;
      this.max = _aggregation[0] ? _aggregation[0].max : 0;
      this.getAggregationType =
        _aggregation[0]?.aggregation?.map((agg) => {
          const isAnomalyCountType = agg?.key === ANOMALY_COUNT;
          return {
            ...agg,
            ...(isAnomalyCountType && { icon: 'starFilled' }),
          };
        }) || [];
      if (
        this.currentMetric.key === Messages.APDEX_CONSTANT.SERVICE_APDEX ||
        this.currentMetric.key === Messages.APDEX_CONSTANT.BROWSER_APP_APDEX
      ) {
        this.thresholdMax = -1;
        if (isFromDRopdownSelected) {
          this.thresholdDisplayValue = 0;
          this.thresholdVal = 0;
        }
      } else
        this.thresholdMax =
          this.max.toString().length > 10 ? 10 : this.max.toString().length;
      if (isFromDRopdownSelected) {
        this.isEdit = false;
      }
      this.currentAggregation = _aggregation[0]
        ? _aggregation[0].aggregation[0]
        : [];

      if (this.currentAggregation && this.currentAggregation.key === 'COUNT') {
        this.showNoOfBreaches = true;
      } else this.showNoOfBreaches = false;
      if (
        this.currentAggregation &&
        this.currentAggregation.key === 'DYNAMIC'
      ) {
        this.showThreshold = false;
        this.showSdMultiplier = true;
      } else if (
        this.currentAggregation &&
        this.currentAggregation.key === ANOMALY_COUNT
      ) {
        this.showThreshold = false;
        this.showSdMultiplier = false;
        this.showAIEnableMessage = !this.enabledAI;
      } else {
        this.showThreshold = true;
        this.showSdMultiplier = false;
      }
      if (
        _aggregation[0] &&
        _aggregation[0].unit &&
        _aggregation[0].unit === 'NUMBER'
      ) {
        this.threashHoldUnitRequired = false;
        this.isThreshHoldUnitRequired = false;
        this.threashHoldTimeUnits = [{ key: 'na', label: '' }];
      } else if (
        _aggregation[0] &&
        _aggregation[0].unit &&
        _aggregation[0].unit === 'STORAGE'
      ) {
        this.threashHoldTimeUnits = [
          { key: 'Bytes', label: 'Bytes' },
          { key: 'KB', label: 'KB' },
          { key: 'MB', label: 'MB' },
          { key: 'GB', label: 'GB' },
        ];
      } else {
        this.threashHoldTimeUnits = [
          { key: 'ms', label: 'ms' },
          { key: 'sec', label: 'sec' },
          { key: 'min', label: 'min' },
          { key: 'hrs', label: 'hrs' },
        ];
      }
      this.selectedthresholdUnit = this.threashHoldTimeUnits[0];
      if (this.showCouchbaseField)
        this.submitButtonDisable = this.validateFields();
      this.selectedThresholdType = _aggregation[0] ? _aggregation[0].unit : '';
      await this.handleThresholdUnitChange(
        isFromDRopdownSelected
          ? this.threashHoldTimeUnits[0]
          : this.selectedthresholdUnit,
      );
      this.currentMetric = option;
      this.invalid.currentMetric = false;
      this.invalid.threshold = false;
      this.invalid.op = false;
      this.invalid.period = false;
      this.invalid.count = false;
      this.invalid.silencePeriod = false;
    },
    onAggregationChange(option) {
      this.showNoOfBreaches = false;
      this.showThreshold = true;
      this.showSdMultiplier = false;
      this.noOfBreachesVal = 0;
      this.sdMulitplierVal = 2;
      this.showAIEnableMessage = false;
      if (!option) return;
      this.currentAggregation = option;
      if (option.key === 'COUNT') {
        this.showNoOfBreaches = true;
        this.noOfBreachesVal = 1;
      }
      if (option.key === ANOMALY_COUNT) {
        this.showThreshold = false;
        this.showAIEnableMessage = !this.enabledAI;
      }
      if (option.key === 'DYNAMIC') {
        this.showThreshold = false;
        this.showSdMultiplier = true;
        this.timePeriodVal = 120;
      }
      if (
        this.currentMetric.label ===
        Messages.OTHERS_CONSTANT.INSTANCE_AVAILABILITY
      ) {
        this.timePeriodVal = 5;
        this.isPeriodReadOnly = 'disabled';
        this.maxLength = 3;
      }
    },
    getWarnInfo(feild) {
      if (
        this.currentMetric &&
        this.currentMetric.warn &&
        this.currentMetric.warn[feild]
      )
        return this.currentMetric.warn[feild];
      switch (feild) {
        case Messages.OTHERS_CONSTANT.THRESHOLD:
          return this.$t('thresholdRangeV2Message');
        case Messages.APDEX_CONSTANT.SERVICE_APDEX:
        case Messages.APDEX_CONSTANT.BROWSER_APP_APDEX:
          return this.$t('apdexRangeV2Message');
        case Messages.OTHERS_CONSTANT._PERIOD:
          return this.$t('periodRangeV2Message');
        case Messages.OTHERS_CONSTANT.THRESHOLD_VALID_LIMIT:
          return this.$t('thresholdValidRangeV2Message');
        default:
          break;
      }
      return '';
    },
    handleEvent(event, _feild) {
      if (
        _feild === 'period' ||
        _feild === 'silence' ||
        _feild === 'recovery' ||
        _feild === 'breaches' ||
        _feild === 'anomalyCount'
      ) {
        AlertsV2Utils.filterKey(event);
      } else {
        if (this.threashHoldUnitRequired) {
          AlertsV2Utils.filterKey(event);
        } else {
          if (
            this.currentMetric.key === Messages.APDEX_CONSTANT.SERVICE_APDEX ||
            this.currentMetric.key === Messages.APDEX_CONSTANT.BROWSER_APP_APDEX
          ) {
            this.handleEventForDecimal(event);
          } else {
            AlertsV2Utils.filterKey(event);
          }
        }
      }
    },
    updateAnomalyCountVal(newVal, disableVal) {
      this.anomalyCountVal = newVal;
      this.submitButtonDisable = disableVal || !this.enabledAI;
    },
    updateSeverity(severity) {
      this.currentSeverity = severity;
    },
    handleEventForDecimal(event) {
      AlertsV2Utils.filterKeyWithDecimalTwoDigits(event);
    },
    handleRowsAction(rows, action, currentRow) {
      this.tagData = rows;
      this.hasError = false;
      this.invalid.tagIds =
        (currentRow?.key?.length === 0) ^ (currentRow?.value?.length === 0);
      this.alertTagErrorMessage = '';
      if (_.difference(rows, _.uniqBy(rows, 'key'), 'key').length > 0) {
        this.hasError = true;
        this.invalid.tagIds = true;
        this.alertTagErrorMessage = this.$t('keyUniqueCheckAlertTagging');
        this.submitButtonDisable = !this.validateFields();
        return;
      }
      if (_.values(rows).some((row) => row.key.length > 20)) {
        this.hasError = true;
        this.invalid.tagIds = true;
        this.alertTagErrorMessage = this.$t('keyCheckingKeyLength');
        this.submitButtonDisable = !this.validateFields();
        return;
      }
      if (_.values(rows).some((row) => row.value.length > 50)) {
        this.hasError = true;
        this.invalid.tagIds = true;
        this.alertTagErrorMessage = this.$t('keyCheckingKeyValueLength');
        this.submitButtonDisable = !this.validateFields();
        return;
      }
      this.submitButtonDisable = !this.validateFields();
    },
    validateTagKeyOnBlur(currentRow) {
      if (currentRow?.key?.length === 0 && currentRow?.value?.length !== 0) {
        this.hasError = true;
        this.invalid.tagIds = true;
        this.alertTagErrorMessage = this.$t('keyEmptyCheckAlertTagging');
        this.submitButtonDisable = !this.validateFields();
      }
      if (
        currentRow?.key?.length !== 0 &&
        (!validateText(currentRow?.key) || !validateText(currentRow?.value))
      ) {
        this.hasError = true;
        this.invalid.tagIds = true;
        this.alertTagErrorMessage = this.$t(
          'keyValueBothEmptyCheckAlertTagging',
        );
        this.submitButtonDisable = !this.validateFields();
      }
    },
    validateTagValueOnBlur(currentRow) {
      if (currentRow?.value?.length === 0 && currentRow?.key?.length !== 0) {
        this.hasError = true;
        this.invalid.tagIds = true;
        this.alertTagErrorMessage = this.$t('valueEmptyCheckAlertTagging');
        this.submitButtonDisable = !this.validateFields();
      }
      if (
        currentRow?.value?.length !== 0 &&
        (!validateText(currentRow?.value) || !validateText(currentRow?.key))
      ) {
        this.hasError = true;
        this.invalid.tagIds = true;
        this.alertTagErrorMessage = this.$t(
          'keyValueBothEmptyCheckAlertTagging',
        );
        this.submitButtonDisable = !this.validateFields();
      }
    },
    onMQChange(selectedList) {
      this.mqInstances = selectedList;
      this.submitButtonDisable = !this.validateFields();
    },
    onK8Change(selectedList) {
      this.K8Instances = selectedList;
      this.submitButtonDisable = !this.validateFields();
    },
    onCouchbaseChange(selectedList) {
      this.couchbaseIntances = selectedList;
      this.submitButtonDisable = !this.validateFields();
    },
    filterOption(input, option) {
      return option?.label
        ? option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        : false;
    },
    onCustomDBChange(selectedList) {
      this.customDbInstances = selectedList;
      this.submitButtonDisable = !this.validateFields();
    },
    getAlertServiceParams() {
      return {
        duration: this.getDurationTime,
        keyword: this.searchAlertService || '',
        pagination: {
          pageNum: this.serviceCurrentPage,
          pageSize: PAGE_SIZE_SCROLL,
          needTotal: true,
        },
        permissions: [permissionTypes.ALERT_WRITE],
      };
    },
    async scrollAlertServices() {
      try {
        this.setServiceCurrentPage(this.serviceCurrentPage + 1);
        this.serviceLoading = true;
        await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
        this.serviceLoading = false;
      } catch (error) {
        console.log('error', error);
        this.serviceLoading = false;
      }
    },
    async onSearchAlertService(val) {
      try {
        this.setServiceCurrentPage(1);
        this.searchAlertService = val;
        this.searchSeviceLoading = true;
        await this.GET_ALERT_APPLICATIONS(this.getAlertServiceParams());
        this.searchSeviceLoading = false;
      } catch (error) {
        console.log('error', error);
        this.searchSeviceLoading = false;
      }
    },
    getEndpointsParams(searchEndpoint = '') {
      return {
        keyword: searchEndpoint || '',
        serviceId: this.getCurrentAlertApplication?.key ?? '',
        pagination: {
          pageNum: this.endpointCurrentPage,
          pageSize: PAGE_SIZE_SCROLL,
          needTotal: true,
        },
      };
    },
    async scrollEndpoints() {
      try {
        this.endpointCurrentPage++;
        this.endpointLoading = true;
        await this.GET_ENDPOINTS(this.getEndpointsParams());
        await this.getEndpointsByServiceId();
        this.endpointLoading = false;
      } catch (error) {
        console.log('error', error);
        this.endpointLoading = false;
      }
    },
    getInstancesParams(searchInstance = '', properties = []) {
      let params = {
        keyword: searchInstance || '',
        serviceId: this.getCurrentAlertApplication?.key ?? '',
        pagination: {
          pageNum: this.instCurrentPage,
          pageSize: PAGE_SIZE_SCROLL,
          needTotal: true,
        },
      };
      if (Array.isArray(properties) && properties.length > 0) {
        params.properties = properties;
      }
      return params;
    },
    async scrollInstances() {
      try {
        this.instCurrentPage++;
        this.instLoading = true;
        await this.GET_INSTANCES_WITH_COUNT(this.getInstancesParams());
        await this.getInstancesByServiceId();
        this.instLoading = false;
      } catch (error) {
        console.log('error', error);
        this.instLoading = false;
      }
    },
  },
  watch: {
    ...mapState('alertV2State/configure', [
      'showAddConfigureAlert',
      'currentCapability',
    ]),
    ...mapState('channelState/overview', ['channels']),
    anomalyCountVal(newValue, oldValue) {
      if (newValue) {
        this.formTopLabelDescription();
      }
    },
    'currentSeverity.key'(newVal, oldValue) {
      if (newVal) {
        this.formTopLabelDescription();
      }
    },
    alertName(newValue, oldValue) {
      this.invalid.alertName = false;
      this.alertNameErrorInfoEnable = false;
      this.alertNameErrorInfo = '';
      if (newValue === '' || newValue?.trim()?.length === 0) {
        this.invalid.alertName = true;
        this.alertNameErrorInfoEnable = true;
        this.alertNameErrorInfo = this.$t('alertNameCantBeEmpty');
      }
      if (newValue.length > 200) {
        this.invalid.alertName = true;
        this.alertNameErrorInfoEnable = true;
        this.alertNameErrorInfo = this.$t('alertNameLength');
        this.submitButtonDisable = !this.validateFields();
      }
      this.submitButtonDisable = !this.validateFields();
    },
    showAddConfigureAlert(newValue, oldValue) {
      this.showModal = newValue;
    },
    currentAggregation(newValue, oldValue) {
      this.onAggregationChange(newValue);
      this.formTopLabelDescription();
      this.submitButtonDisable = !this.validateFields();
    },
    currentMetric(newValue, oldValue) {
      if (!newValue) return;
      this.onMetricChange(newValue);
      this.invalid.threshold = false;
      if (
        Number(this.thresholdVal) >= this.min &&
        Number(this.thresholdVal) <= this.max
      ) {
        this.invalid.threshold = false;
      } else {
        this.invalid.threshold = true;
      }
      this.statusTypeArray = StatusType[this.currentMetric.key];
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    currentOp(newValue, oldValue) {
      this.formTopLabelDescription();
    },
    thresholdVal(newValue, oldValue) {
      newValue = Number(newValue);
      this.invalid.threshold = false;
      if (Number(newValue) >= this.min && Number(newValue) <= this.max) {
        this.invalid.threshold = false;
      } else {
        this.invalid.threshold = true;
      }
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    noOfBreachesVal(newValue, oldValue) {
      newValue = Number(newValue);
      this.noOfBreachesInfoEnable = false;
      this.noOfBreachesInfo = '';
      this.invalid.noOfBreaches = false;
      if (
        (newValue <= 0 ||
          newValue === '' ||
          newValue === undefined ||
          newValue === null) &&
        this.showNoOfBreaches
      ) {
        this.invalid.noOfBreaches = true;
        this.noOfBreachesInfoEnable = true;
        this.noOfBreachesInfo = this.$t('noOfBreachesValidationMessage');
      }
      this.submitButtonDisable = !this.validateFields();
      this.formTopLabelDescription();
    },
    currentApplication() {
      this.formTopLabelDescription();
    },
    selectedErrorCode() {
      this.formTopLabelDescription();
    },
    selectedStatusType() {
      this.formTopLabelDescription();
    },
    statusTypeArray() {
      this.selectedStatusType = {};
    },
    async currentK8Instance() {
      await this.getMetricsByCapability();
      if (this.metrics.length > 0) {
        this.metrics = transformAndSortMetrics(this.metrics);
        this.currentMetric = this.metrics[0];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modalRow {
  padding-top: 2.5em;
  padding-left: 2.5em;
  color: $font-primary;
  min-width: 50em;
  text-align: left;
}
.modalCol {
  padding-left: 1.25em;
  font-family: $semi-bold !important;
}
.modalOption {
  padding-top: 0.9375em;
  max-width: 18.75em;
  font-family: $regular !important;
}
.modalSub2 {
  padding-top: 0.75em;
  font-size: 0.75em;

  font-family: $regular !important;
  max-width: 18.75em;
}
.modalSub {
  padding-top: 0em;
  font-size: 0.75em;

  font-family: $regular !important;
  max-width: 24.75em;
}
.modalFootRow {
  padding-left: 1.25em;
  font-family: $regular !important;
}
.modalFootCol {
  padding-left: 0.625em;
}
.validation {
  color: $poor;
  font-family: $regular !important;
  max-width: 77% !important;
}
.modal-dialog-centered {
  justify-content: center;
}
@media (max-width: 992px) {
  .modal-vlg,
  .modal-xl {
    max-width: 1150px;
  }
}
.modal-body-top {
  padding: 1.5rem 0em 1.5em 0em !important;
}
.modal-btn {
  display: flex;
  justify-content: flex-end;
}
.select {
  line-height: 1.375em;
  color: $bg-primary;
  background-color: transparent;
  margin-right: 0.6em;
  text-align: left;
}
.clear-filter {
  margin-right: 10px;
  // margin-left: 10px;
  text-decoration: underline;
  color: $color-brand-accent;
  cursor: pointer;
  align-items: flex-end;
}
.max-width {
  width: 100%;
  max-width: 20.75em !important;
}
.alert-form-subtext {
  margin: -1em 0em 1em 0em;
}
.alert-form-subtext-highlight {
  color: #f59600;
  font-weight: bold;
}
.select-field {
  width: 20.75em;
  &:deep(.ant-select-selector) {
    @include flex-center-vert;
    background-color: $bg-primary;
    border: 0.0625em solid rgba(255, 255, 255, 0.3);
    height: 100%;
  }
}
.select-field {
  &:deep(.ant-select-selection-item) {
    color: rgb(255, 255, 255);
  }
}
</style>
